export default {
	phone: {
		chinese:{
			banner:require('@/images/mobile/pressCenter/1-0.png'),
			sliderList:['公司动态', '媒体报道'],
			more:'加载更多',
			newDetails:{
				title:'新闻导览',
				returnList:'返回列表'
			}
		},
		english:{
			banner:require('@/images/mobile/english/banner_pressCenter.png'),
			sliderListYW:['Company News', 'Media Reports'],
			more:'More',
			newDetails:{
				title:'Press the navigation',
				returnList:'Returns a list of'
			}
		}
		
	},
	pc: {
		chinese:{
			banner:require('@/images/presscenter/5-1.png'),
			sliderList:['公司动态', '媒体报道'],
			more:'加载更多',
			newDetails:{
				title:'新闻导览',
				returnList:'返回列表'
			}
		},
		english:{
			banner:require('@/images/english/banner_pressCenter.png'),
			sliderListYW:['Company News', 'Media Reports'],
			more:'More',
			newDetails:{
				title:'Press the navigation',
				returnList:'Returns a list of'
			}
		}
		
	}

}



// WEBPACK FOOTER //
// ./src/utils/lang/presscenter.js